import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "rescigo_courier_token";

export const courierApi = axios.create({ baseURL: API });
courierApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const setCourierToken = (t) => localStorage.setItem(KEY, t);
export const getCourierToken = () => localStorage.getItem(KEY);
export const clearCourierToken = () => localStorage.removeItem(KEY);
export const isCourierAuthed = () => !!localStorage.getItem(KEY);

export function fmtCourierErr(e) {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join("; ");
  return d || e?.message || "Request failed";
}
